import PropTypes from 'prop-types';
import React from 'react';

import Formsy from 'formsy-react';
import { FormBody, FormFooter, Button, Row, Col } from 'twyne-new.ui';

import UserForm from 'modules/admin/views/user/components/UserForm'
import appStore from 'stores/app';
import history from 'utils/history';

import { useProfileStore } from '../store';

class MyProfile extends React.Component {
  state = {
    gender: null,
    active: true,
    changePassword: false,
    password: "",
    siteID: this.props.siteID || appStore.currentSiteID || null,
  };

  componentWillMount() {
    const { data } = this.props;
    if (data) {
      this.setState(data);
    }
  }

  componentWillReceiveProps(props) {
    const data = props.data;
    if (data) {
      this.setState(data);
    }
  }

  handleValidSubmit = model => {
    const { email: _email, ...payload } = model
    payload.is_admin = true;
    this.props.handleSubmit(Object.assign(this.state, payload));
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit} >
        <FormBody>
          <UserForm useUserStore={useProfileStore} data={this.state} type='profile' />
          <FormFooter>
            <Button type="submit" color="accent">Save</Button>
            <Button onClick={() => history.goBack()} variant="ghost">Cancel</Button>
          </FormFooter>
        </FormBody>
      </Formsy>
    );
  }
}

MyProfile.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any,
};

export default MyProfile;
